const PROTOCOL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;

function trimTrailingSlash(pathname: string) {
  if (!pathname || pathname === '/') return pathname;
  return pathname.replace(/\/+$/, '');
}

export function normalizeCanonicalUrl(url: string): string {
  const trimmedUrl = url.trim();
  if (!trimmedUrl) return trimmedUrl;

  if (PROTOCOL_REGEX.test(trimmedUrl)) {
    try {
      const parsed = new URL(trimmedUrl);
      parsed.pathname = trimTrailingSlash(parsed.pathname) || '/';
      return `${parsed.origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      // fall through to relative handling
    }
  }

  const queryIndex = trimmedUrl.search(/[?#]/);
  const pathname =
    queryIndex === -1 ? trimmedUrl : trimmedUrl.slice(0, queryIndex);
  const suffix = queryIndex === -1 ? '' : trimmedUrl.slice(queryIndex);

  if (!pathname || pathname === '/') {
    return `${pathname}${suffix}`;
  }

  return `${trimTrailingSlash(pathname)}${suffix}`;
}
